import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import type { ComputedRef, Ref } from 'vue';

interface UseResponsive {
    breakpoints: ReturnType<typeof useBreakpoints<keyof typeof breakpointsTailwind>>;
    isMobile: Ref<boolean>;
    isMobileOrTablet: Ref<boolean>;
    isTablet: ComputedRef<boolean>;
    isTabletOrDesktop: Ref<boolean>;
    isLgOrGreater: Ref<boolean>;
    isXlOrGreater: Ref<boolean>;
}

export const useResponsive = (): UseResponsive => {
    const breakpoints = useBreakpoints(breakpointsTailwind);

    return {
        breakpoints,
        isMobile: breakpoints.smaller('md'),
        isMobileOrTablet: breakpoints.smaller('lg'),
        isTablet: computed(() => breakpoints.active().value === 'md'),
        isTabletOrDesktop: breakpoints.greaterOrEqual('md'),
        isLgOrGreater: breakpoints.greaterOrEqual('lg'),
        isXlOrGreater: breakpoints.greaterOrEqual('xl'),
    };
};
